import { render, staticRenderFns } from "./program-rating.vue?vue&type=template&id=4c3f2418&"
import script from "./program-rating.vue?vue&type=script&lang=ts&"
export * from "./program-rating.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports